import { render, staticRenderFns } from "./textController.vue?vue&type=template&id=bb7687e0&"
import script from "./textController.vue?vue&type=script&lang=ts&"
export * from "./textController.vue?vue&type=script&lang=ts&"
import style0 from "./textController.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports